import { type EdgeTypes } from "@xyflow/react";
import Decimal from "decimal.js";
import {
  getOwningId,
  getUniqueInvestingEdgeKey,
} from "features/entities/EntityCreatePage/EntityGraph/edges/edgeUtils";
import { AppEdge } from "features/entities/EntityCreatePage/EntityGraph/edges/types";
import { SecurityOwnershipsGroupedByOwnedId } from "features/entities/EntityCreatePage/EntityGraph/entityGraphTypes";
import { Entity } from "features/entities/EntityCreatePage/EntityGraph/nodes/types";
import { SecurityOwnershipWithEntityDataList } from "gen/model/securityOwnershipWithEntityDataList";
import uniqBy from "lodash-es/uniqBy";
import { formatPercentage } from "shared/utils/formattingUtils";

export const getInitialEdges = (
  securities: SecurityOwnershipWithEntityDataList,
  securityOwnershipWeight: Record<string, number>,
  entityMap: Record<string, Entity>,
  securitiesGroupedByInvestingInto: SecurityOwnershipsGroupedByOwnedId,
): AppEdge[] =>
  uniqBy(securities, (sec) =>
    getUniqueInvestingEdgeKey(sec, securitiesGroupedByInvestingInto, entityMap),
  ).map((security) => {
    const owningId = getOwningId(
      security,
      securitiesGroupedByInvestingInto,
      entityMap,
    );

    return {
      id: security.security_ownership_id,
      source: owningId,
      target: security.owned_entity_id,
      label: formatPercentage(
        new Decimal(
          securityOwnershipWeight[
            getUniqueInvestingEdgeKey(
              security,
              securitiesGroupedByInvestingInto,
              entityMap,
            )
          ] * 100,
        ),
      ),
    };
  });

export const edgeTypes = {} satisfies EdgeTypes;
